import { ref, reactive } from "vue";
import axios from "axios";
import router from "../../router/shop";
import Auth from "./auth";
import { useToast } from "vue-toastification";
import { useRoute } from "vue-router";
export default function useProducts() {
  const route = useRoute();
  const page = ref(1);
  const product = reactive({});
  const products = ref([]);
  const sendOrders = reactive({ data: [], description: "" });
  const introductionBrand = ref(null);
  const loading = ref(true);
  const selectedCategory = ref(route.query.category?.split(',') || []);
  const selectedCar = ref(route.query.car?.split(',') || []);
  const selectedBrand = ref(route.query.brand?.split(',') || []);
  const categories = ref([]);
  const filterCategories = ref([]);
  const brands = ref([]);
  const cars = ref([]);
  const cart = reactive({checks: [],check: '',confirm: false});
  const controller = ref(null);
  const isReserve = ref(false);
  const reserve = ref(null);
  const progressDialog = window.progressDialog;
  const meta = reactive({});
  const exportData = reactive({ brand: "", in_stock: false});
  const errors = ref("");
  const toast = useToast();
  const grid = ref(localStorage.getItem("product_grid") === "true");
  const getProducts = async (query) => {
    try {
      errors.value = "";
      loading.value = true;
      let search = query ? "?" + new URLSearchParams(query).toString() : "";
      if(router.currentRoute.value.meta?.type) search += '&type=' + router.currentRoute.value.meta.type;
      // if(query.out_stock == undefined) search += '&out_stock=1'
      controller.value = new AbortController();
      let response = await axios.get("product" + search,{signal: controller.value.signal});
      loading.value = false;
      Object.assign(meta, response.data.meta);
      meta.check_condition = response.data.check_condition;
      meta.show_out_stock = response.data.show_out_stock;
      if(meta.current_page > 1)products.value.push(...response.data.data);
      else products.value = response.data.data;
    } catch (e) {
      if(!meta.current_page)errors.value = e;
      loading.value = false;
    }
  };

  const getProduct = async (slug) => {
    try {
      Object.assign(product,{gallery: []});
      progressDialog.value = true;
      let response = await axios.get("product/" + slug);
      Object.assign(product, response.data.data);
      document.getElementById('product-modal').checked = true;
      progressDialog.value = false;
      window.location.hash = "product";
    } catch (e) {
      window.networkError(e);
      progressDialog.value = false;
    }
  };

  const getCategories = async (attribute = 'primary', open = true,dialog = true) => {
    const category = document.getElementById("category-modal");
    const barnd = document.getElementById(attribute === 'intro_brand' ? "intro-brand-modal" : "brand-modal");
    const car = document.getElementById("car-modal");
    if(attribute === 'intro_brand') attribute = 'brand';
    if (attribute == 'primary' && categories.value.length) {
      if (open) category.checked = true;
      return false;
    }else if (attribute === "brand" && brands.value.length) {
      if (open) barnd.checked = true;
      return false;
    } else if (attribute === "car" && cars.value.length) {
      if (open) car.checked = true;
      return false;
    }
    try {
      if(dialog)progressDialog.value = true;
      else loading.value = true;
      let response = await axios.get("product/category?type=" + attribute);
      if (attribute === "brand") {
        brands.value.push(...response.data.data);
        if (open) barnd.checked = true;
      } else if(attribute === "car") {
        cars.value.push(...response.data.data);
        if (open) car.checked = true;
      }else{
        categories.value.push(...response.data.data);
        filterCategories.value.push(...response.data.data);
        if (open) category.checked = true;
      }
      if(dialog) progressDialog.value = false;
      else loading.value = false;
    } catch (e) {
      window.networkError(e);
      if(dialog) progressDialog.value = false;
      else loading.value = false;
    }
  };

  const getSendOrders = async () => {
    try {
      errors.value = "";
      loading.value = true;
      let response = await axios.get("send-order");
      sendOrders.data = response.data.data;
      if(sendOrders.data.length)sendOrders.description = response.data.description;
      loading.value = false;
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

  const changeLayout = () => {
    grid.value = !grid.value;
    localStorage.setItem("product_grid", grid.value);
  };

  const getCart = async (type = '') => {
    try {
      errors.value = "";
      loading.value = true;
      let response = await axios.get("cart" + (type ? '?type=' + type : ''));
      loading.value = false;
      const data = response.data;
      products.value = data.data;
      meta.check_condition = response.data.check_condition;
      delete data.data;
      Object.assign(cart,data); 
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

  const getReserve = async () => {
    try {
      errors.value = "";
      loading.value = true;
      let response = await axios.get("reserve");
      loading.value = false;
      const data = response.data;
      products.value = data.data;
      meta.check_condition = response.data.check_condition;
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

  const storeCart = async (product, num,status = 1) => {
    try {
      if(!num)return true;
      progressDialog.value = true;
      let response = await axios.post("cart", {
        product_id: product.id,
        quantity: num,
        status: status,
      });
      const {check,cash,total,count,quantity,changed} = response.data;
      Object.assign(cart,response.data)
      Object.assign(Auth.user.value.cart,{check,cash,total,count});
      if(changed) toast.error(response.data.message);
      else if(product.quantity === 0)toast.success(response.data.message);
      product.quantity = quantity;
      progressDialog.value = false;
    } catch (e) {
      window.networkError(e);
      progressDialog.value = false;
    }
  };

  const updateCart = async () => {
    try {
      progressDialog.value = true;
      let response = await axios.put("cart");
      const {check,cash,total,count} = response.data;
      Object.assign(Auth.user.value.cart,{check,cash,total,count});
      products.value = products.value.filter(item => item.stock_status == 'out_stock');
      toast.success(response.data.message);
      progressDialog.value = false;
    } catch (e) {
      window.networkError(e);
      progressDialog.value = false;
    }
  };

  const removeCart = async (product, force = false) => {
    try {
      progressDialog.value = true;
      let response = await axios.delete("cart/" + product.id);
      progressDialog.value = false;
      const {check,cash,total,count} = response.data;
      Object.assign(cart,response.data);
      Object.assign(Auth.user.value.cart,{check,cash,total,count});
      if (force) {
        toast.error(response.data.message);
        const index = products.value.findIndex(item => item.id == product.id);
        products.value.splice(index,1);
      }else product.quantity = 0;
    } catch (e) {
      window.networkError(e);
      progressDialog.value = false;
    }
  };

  const exportProduct = async () => {
    try {
      progressDialog.value = true;
      let response = await axios.post("product/export", exportData);
      const link = document.createElement("a");
      link.href = response.data.link;
      link.click();
      URL.revokeObjectURL(link.href);
      progressDialog.value = false;
    } catch (e) {
      window.networkError(e);
      progressDialog.value = false;
    }
  };

  const changeQuantity = (product, quantity) => {
    if(!reserve.value && product.stock_status === 'out_stock'){
      reserve.value = product;
      return false;
    } else if (quantity > 0) storeCart(product,quantity,isReserve.value ? 0 : !reserve.value);
    else if(product.quantity > 0 && quantity == 0) removeCart(product,route.name == 'cart');
    reserve.value = null;
  };

  return {
    errors,
    changeLayout,
    changeQuantity,
    loading,
    progressDialog,
    meta,
    page,
    products,
    product,
    sendOrders,
    brands,
    isReserve,
    controller,
    categories,
    cart,
    cars,
    exportData,
    filterCategories,
    selectedCategory,
    selectedCar,
    selectedBrand,
    reserve,
    introductionBrand,
    exportProduct,
    getCategories,
    getReserve,
    getProducts,
    getSendOrders,
    getProduct,
    getCart,
    storeCart,
    updateCart,
    removeCart,
    grid,
    toast,
    route,
    router,
  };
}
